var map = {
	"./characters/cursive/connections/char-ad.png": 497,
	"./characters/cursive/connections/char-bo.png": 498,
	"./characters/cursive/connections/char-by.png": 499,
	"./characters/cursive/connections/char-cc.png": 500,
	"./characters/cursive/connections/char-ch.png": 501,
	"./characters/cursive/connections/char-ed.png": 502,
	"./characters/cursive/connections/char-el.png": 503,
	"./characters/cursive/connections/char-gl.png": 504,
	"./characters/cursive/connections/char-it.png": 505,
	"./characters/cursive/connections/char-oa.png": 506,
	"./characters/cursive/connections/char-oe.png": 507,
	"./characters/cursive/connections/char-of.png": 508,
	"./characters/cursive/connections/char-oi.png": 509,
	"./characters/cursive/connections/char-on.png": 510,
	"./characters/cursive/connections/char-or.png": 511,
	"./characters/cursive/connections/char-os.png": 512,
	"./characters/cursive/connections/char-pa.png": 513,
	"./characters/cursive/connections/char-tr.png": 514,
	"./characters/cursive/connections/char-us.png": 515,
	"./characters/cursive/connections/char-ve.png": 516,
	"./characters/cursive/connections/char-wa.png": 517,
	"./characters/cursive/connections/char-wh.png": 518,
	"./characters/cursive/connections/char-wi.png": 519,
	"./characters/cursive/connections/char-yo.png": 520,
	"./characters/cursive/lowercase/char-a.png": 521,
	"./characters/cursive/lowercase/char-b.png": 522,
	"./characters/cursive/lowercase/char-c.png": 523,
	"./characters/cursive/lowercase/char-d.png": 524,
	"./characters/cursive/lowercase/char-e.png": 525,
	"./characters/cursive/lowercase/char-f.png": 526,
	"./characters/cursive/lowercase/char-g.png": 527,
	"./characters/cursive/lowercase/char-h.png": 528,
	"./characters/cursive/lowercase/char-i.png": 529,
	"./characters/cursive/lowercase/char-j.png": 530,
	"./characters/cursive/lowercase/char-k.png": 531,
	"./characters/cursive/lowercase/char-l.png": 532,
	"./characters/cursive/lowercase/char-m.png": 533,
	"./characters/cursive/lowercase/char-n.png": 534,
	"./characters/cursive/lowercase/char-o.png": 535,
	"./characters/cursive/lowercase/char-p.png": 536,
	"./characters/cursive/lowercase/char-q.png": 537,
	"./characters/cursive/lowercase/char-r.png": 538,
	"./characters/cursive/lowercase/char-s.png": 539,
	"./characters/cursive/lowercase/char-t.png": 540,
	"./characters/cursive/lowercase/char-u.png": 541,
	"./characters/cursive/lowercase/char-v.png": 542,
	"./characters/cursive/lowercase/char-w.png": 543,
	"./characters/cursive/lowercase/char-x.png": 544,
	"./characters/cursive/lowercase/char-y.png": 545,
	"./characters/cursive/lowercase/char-z.png": 546,
	"./characters/cursive/uppercase/char-A.png": 547,
	"./characters/cursive/uppercase/char-B.png": 548,
	"./characters/cursive/uppercase/char-C.png": 549,
	"./characters/cursive/uppercase/char-D.png": 550,
	"./characters/cursive/uppercase/char-E.png": 551,
	"./characters/cursive/uppercase/char-F.png": 552,
	"./characters/cursive/uppercase/char-G.png": 553,
	"./characters/cursive/uppercase/char-H.png": 554,
	"./characters/cursive/uppercase/char-I.png": 555,
	"./characters/cursive/uppercase/char-J.png": 556,
	"./characters/cursive/uppercase/char-K.png": 557,
	"./characters/cursive/uppercase/char-L.png": 558,
	"./characters/cursive/uppercase/char-M.png": 559,
	"./characters/cursive/uppercase/char-N.png": 560,
	"./characters/cursive/uppercase/char-O.png": 561,
	"./characters/cursive/uppercase/char-P.png": 562,
	"./characters/cursive/uppercase/char-Q.png": 563,
	"./characters/cursive/uppercase/char-R.png": 564,
	"./characters/cursive/uppercase/char-S.png": 565,
	"./characters/cursive/uppercase/char-T.png": 566,
	"./characters/cursive/uppercase/char-U.png": 567,
	"./characters/cursive/uppercase/char-V.png": 568,
	"./characters/cursive/uppercase/char-W.png": 569,
	"./characters/cursive/uppercase/char-X.png": 570,
	"./characters/cursive/uppercase/char-Y.png": 571,
	"./characters/cursive/uppercase/char-Z.png": 572,
	"./characters/numbers/char-0.png": 161,
	"./characters/numbers/char-1.png": 162,
	"./characters/numbers/char-2.png": 163,
	"./characters/numbers/char-3.png": 164,
	"./characters/numbers/char-4.png": 165,
	"./characters/numbers/char-5.png": 166,
	"./characters/numbers/char-6.png": 167,
	"./characters/numbers/char-7.png": 168,
	"./characters/numbers/char-8.png": 169,
	"./characters/numbers/char-9.png": 170,
	"./characters/print/lowercase/char-a.png": 197,
	"./characters/print/lowercase/char-b.png": 198,
	"./characters/print/lowercase/char-c.png": 199,
	"./characters/print/lowercase/char-d.png": 200,
	"./characters/print/lowercase/char-e.png": 201,
	"./characters/print/lowercase/char-f.png": 202,
	"./characters/print/lowercase/char-g.png": 203,
	"./characters/print/lowercase/char-h.png": 204,
	"./characters/print/lowercase/char-i.png": 205,
	"./characters/print/lowercase/char-j.png": 206,
	"./characters/print/lowercase/char-k.png": 207,
	"./characters/print/lowercase/char-l.png": 208,
	"./characters/print/lowercase/char-m.png": 209,
	"./characters/print/lowercase/char-n.png": 210,
	"./characters/print/lowercase/char-o.png": 211,
	"./characters/print/lowercase/char-p.png": 212,
	"./characters/print/lowercase/char-q.png": 213,
	"./characters/print/lowercase/char-r.png": 214,
	"./characters/print/lowercase/char-s.png": 215,
	"./characters/print/lowercase/char-t.png": 216,
	"./characters/print/lowercase/char-u.png": 217,
	"./characters/print/lowercase/char-v.png": 218,
	"./characters/print/lowercase/char-w.png": 219,
	"./characters/print/lowercase/char-x.png": 220,
	"./characters/print/lowercase/char-y.png": 221,
	"./characters/print/lowercase/char-z.png": 222,
	"./characters/print/uppercase/char-A.png": 171,
	"./characters/print/uppercase/char-B.png": 172,
	"./characters/print/uppercase/char-C.png": 173,
	"./characters/print/uppercase/char-D.png": 174,
	"./characters/print/uppercase/char-E.png": 175,
	"./characters/print/uppercase/char-F.png": 176,
	"./characters/print/uppercase/char-G.png": 177,
	"./characters/print/uppercase/char-H.png": 178,
	"./characters/print/uppercase/char-I.png": 179,
	"./characters/print/uppercase/char-J.png": 180,
	"./characters/print/uppercase/char-K.png": 181,
	"./characters/print/uppercase/char-L.png": 182,
	"./characters/print/uppercase/char-M.png": 183,
	"./characters/print/uppercase/char-N.png": 184,
	"./characters/print/uppercase/char-O.png": 185,
	"./characters/print/uppercase/char-P.png": 186,
	"./characters/print/uppercase/char-Q.png": 187,
	"./characters/print/uppercase/char-R.png": 188,
	"./characters/print/uppercase/char-S.png": 189,
	"./characters/print/uppercase/char-T.png": 190,
	"./characters/print/uppercase/char-U.png": 191,
	"./characters/print/uppercase/char-V.png": 192,
	"./characters/print/uppercase/char-W.png": 193,
	"./characters/print/uppercase/char-X.png": 194,
	"./characters/print/uppercase/char-Y.png": 195,
	"./characters/print/uppercase/char-Z.png": 196,
	"./lock.png": 573,
	"./plain-stickers/cursive/connection/plain-sticker-ad.png": 281,
	"./plain-stickers/cursive/connection/plain-sticker-bo.png": 282,
	"./plain-stickers/cursive/connection/plain-sticker-by.png": 283,
	"./plain-stickers/cursive/connection/plain-sticker-cc.png": 284,
	"./plain-stickers/cursive/connection/plain-sticker-ch.png": 285,
	"./plain-stickers/cursive/connection/plain-sticker-ed.png": 286,
	"./plain-stickers/cursive/connection/plain-sticker-el.png": 287,
	"./plain-stickers/cursive/connection/plain-sticker-gl.png": 288,
	"./plain-stickers/cursive/connection/plain-sticker-it.png": 289,
	"./plain-stickers/cursive/connection/plain-sticker-oa.png": 290,
	"./plain-stickers/cursive/connection/plain-sticker-oe.png": 291,
	"./plain-stickers/cursive/connection/plain-sticker-of.png": 292,
	"./plain-stickers/cursive/connection/plain-sticker-oi.png": 293,
	"./plain-stickers/cursive/connection/plain-sticker-on.png": 294,
	"./plain-stickers/cursive/connection/plain-sticker-or.png": 295,
	"./plain-stickers/cursive/connection/plain-sticker-os.png": 296,
	"./plain-stickers/cursive/connection/plain-sticker-pa.png": 297,
	"./plain-stickers/cursive/connection/plain-sticker-tr.png": 298,
	"./plain-stickers/cursive/connection/plain-sticker-us.png": 299,
	"./plain-stickers/cursive/connection/plain-sticker-ve.png": 300,
	"./plain-stickers/cursive/connection/plain-sticker-wa.png": 301,
	"./plain-stickers/cursive/connection/plain-sticker-wh.png": 302,
	"./plain-stickers/cursive/connection/plain-sticker-wi.png": 303,
	"./plain-stickers/cursive/connection/plain-sticker-yo.png": 304,
	"./plain-stickers/cursive/lowercase/plain-sticker-a.png": 305,
	"./plain-stickers/cursive/lowercase/plain-sticker-b.png": 306,
	"./plain-stickers/cursive/lowercase/plain-sticker-c.png": 307,
	"./plain-stickers/cursive/lowercase/plain-sticker-d.png": 308,
	"./plain-stickers/cursive/lowercase/plain-sticker-e.png": 309,
	"./plain-stickers/cursive/lowercase/plain-sticker-f.png": 310,
	"./plain-stickers/cursive/lowercase/plain-sticker-g.png": 311,
	"./plain-stickers/cursive/lowercase/plain-sticker-h.png": 312,
	"./plain-stickers/cursive/lowercase/plain-sticker-i.png": 313,
	"./plain-stickers/cursive/lowercase/plain-sticker-j.png": 314,
	"./plain-stickers/cursive/lowercase/plain-sticker-k.png": 315,
	"./plain-stickers/cursive/lowercase/plain-sticker-l.png": 316,
	"./plain-stickers/cursive/lowercase/plain-sticker-m.png": 317,
	"./plain-stickers/cursive/lowercase/plain-sticker-n.png": 318,
	"./plain-stickers/cursive/lowercase/plain-sticker-o.png": 319,
	"./plain-stickers/cursive/lowercase/plain-sticker-p.png": 320,
	"./plain-stickers/cursive/lowercase/plain-sticker-q.png": 321,
	"./plain-stickers/cursive/lowercase/plain-sticker-r.png": 322,
	"./plain-stickers/cursive/lowercase/plain-sticker-s.png": 323,
	"./plain-stickers/cursive/lowercase/plain-sticker-t.png": 324,
	"./plain-stickers/cursive/lowercase/plain-sticker-u.png": 325,
	"./plain-stickers/cursive/lowercase/plain-sticker-v.png": 326,
	"./plain-stickers/cursive/lowercase/plain-sticker-w.png": 327,
	"./plain-stickers/cursive/lowercase/plain-sticker-x.png": 328,
	"./plain-stickers/cursive/lowercase/plain-sticker-y.png": 329,
	"./plain-stickers/cursive/lowercase/plain-sticker-z.png": 330,
	"./plain-stickers/cursive/uppercase/plain-sticker-A.png": 331,
	"./plain-stickers/cursive/uppercase/plain-sticker-B.png": 332,
	"./plain-stickers/cursive/uppercase/plain-sticker-C.png": 333,
	"./plain-stickers/cursive/uppercase/plain-sticker-D.png": 334,
	"./plain-stickers/cursive/uppercase/plain-sticker-E.png": 335,
	"./plain-stickers/cursive/uppercase/plain-sticker-F.png": 336,
	"./plain-stickers/cursive/uppercase/plain-sticker-G.png": 337,
	"./plain-stickers/cursive/uppercase/plain-sticker-H.png": 338,
	"./plain-stickers/cursive/uppercase/plain-sticker-I.png": 339,
	"./plain-stickers/cursive/uppercase/plain-sticker-J.png": 340,
	"./plain-stickers/cursive/uppercase/plain-sticker-K.png": 341,
	"./plain-stickers/cursive/uppercase/plain-sticker-L.png": 342,
	"./plain-stickers/cursive/uppercase/plain-sticker-M.png": 343,
	"./plain-stickers/cursive/uppercase/plain-sticker-N.png": 344,
	"./plain-stickers/cursive/uppercase/plain-sticker-O.png": 345,
	"./plain-stickers/cursive/uppercase/plain-sticker-P.png": 346,
	"./plain-stickers/cursive/uppercase/plain-sticker-Q.png": 347,
	"./plain-stickers/cursive/uppercase/plain-sticker-R.png": 348,
	"./plain-stickers/cursive/uppercase/plain-sticker-S.png": 349,
	"./plain-stickers/cursive/uppercase/plain-sticker-T.png": 350,
	"./plain-stickers/cursive/uppercase/plain-sticker-U.png": 351,
	"./plain-stickers/cursive/uppercase/plain-sticker-V.png": 352,
	"./plain-stickers/cursive/uppercase/plain-sticker-W.png": 353,
	"./plain-stickers/cursive/uppercase/plain-sticker-X.png": 354,
	"./plain-stickers/cursive/uppercase/plain-sticker-Y.png": 355,
	"./plain-stickers/cursive/uppercase/plain-sticker-Z.png": 356,
	"./plain-stickers/numbers/plain-sticker-0.png": 61,
	"./plain-stickers/numbers/plain-sticker-1.png": 62,
	"./plain-stickers/numbers/plain-sticker-2.png": 63,
	"./plain-stickers/numbers/plain-sticker-3.png": 64,
	"./plain-stickers/numbers/plain-sticker-4.png": 65,
	"./plain-stickers/numbers/plain-sticker-5.png": 66,
	"./plain-stickers/numbers/plain-sticker-6.png": 67,
	"./plain-stickers/numbers/plain-sticker-7.png": 68,
	"./plain-stickers/numbers/plain-sticker-8.png": 69,
	"./plain-stickers/numbers/plain-sticker-9.png": 70,
	"./plain-stickers/print/lowercase/plain-sticker-a.png": 97,
	"./plain-stickers/print/lowercase/plain-sticker-b.png": 98,
	"./plain-stickers/print/lowercase/plain-sticker-c.png": 99,
	"./plain-stickers/print/lowercase/plain-sticker-d.png": 100,
	"./plain-stickers/print/lowercase/plain-sticker-e.png": 101,
	"./plain-stickers/print/lowercase/plain-sticker-f.png": 102,
	"./plain-stickers/print/lowercase/plain-sticker-g.png": 103,
	"./plain-stickers/print/lowercase/plain-sticker-h.png": 104,
	"./plain-stickers/print/lowercase/plain-sticker-i.png": 105,
	"./plain-stickers/print/lowercase/plain-sticker-j.png": 106,
	"./plain-stickers/print/lowercase/plain-sticker-k.png": 107,
	"./plain-stickers/print/lowercase/plain-sticker-l.png": 108,
	"./plain-stickers/print/lowercase/plain-sticker-m.png": 109,
	"./plain-stickers/print/lowercase/plain-sticker-n.png": 110,
	"./plain-stickers/print/lowercase/plain-sticker-o.png": 111,
	"./plain-stickers/print/lowercase/plain-sticker-p.png": 112,
	"./plain-stickers/print/lowercase/plain-sticker-q.png": 113,
	"./plain-stickers/print/lowercase/plain-sticker-r.png": 114,
	"./plain-stickers/print/lowercase/plain-sticker-s.png": 115,
	"./plain-stickers/print/lowercase/plain-sticker-t.png": 116,
	"./plain-stickers/print/lowercase/plain-sticker-u.png": 117,
	"./plain-stickers/print/lowercase/plain-sticker-v.png": 118,
	"./plain-stickers/print/lowercase/plain-sticker-w.png": 119,
	"./plain-stickers/print/lowercase/plain-sticker-x.png": 120,
	"./plain-stickers/print/lowercase/plain-sticker-y.png": 121,
	"./plain-stickers/print/lowercase/plain-sticker-z.png": 122,
	"./plain-stickers/print/uppercase/plain-sticker-A.png": 71,
	"./plain-stickers/print/uppercase/plain-sticker-B.png": 72,
	"./plain-stickers/print/uppercase/plain-sticker-C.png": 73,
	"./plain-stickers/print/uppercase/plain-sticker-D.png": 74,
	"./plain-stickers/print/uppercase/plain-sticker-E.png": 75,
	"./plain-stickers/print/uppercase/plain-sticker-F.png": 76,
	"./plain-stickers/print/uppercase/plain-sticker-G.png": 77,
	"./plain-stickers/print/uppercase/plain-sticker-H.png": 78,
	"./plain-stickers/print/uppercase/plain-sticker-I.png": 79,
	"./plain-stickers/print/uppercase/plain-sticker-J.png": 80,
	"./plain-stickers/print/uppercase/plain-sticker-K.png": 81,
	"./plain-stickers/print/uppercase/plain-sticker-L.png": 82,
	"./plain-stickers/print/uppercase/plain-sticker-M.png": 83,
	"./plain-stickers/print/uppercase/plain-sticker-N.png": 84,
	"./plain-stickers/print/uppercase/plain-sticker-O.png": 85,
	"./plain-stickers/print/uppercase/plain-sticker-P.png": 86,
	"./plain-stickers/print/uppercase/plain-sticker-Q.png": 87,
	"./plain-stickers/print/uppercase/plain-sticker-R.png": 88,
	"./plain-stickers/print/uppercase/plain-sticker-S.png": 89,
	"./plain-stickers/print/uppercase/plain-sticker-T.png": 90,
	"./plain-stickers/print/uppercase/plain-sticker-U.png": 91,
	"./plain-stickers/print/uppercase/plain-sticker-V.png": 92,
	"./plain-stickers/print/uppercase/plain-sticker-W.png": 93,
	"./plain-stickers/print/uppercase/plain-sticker-X.png": 94,
	"./plain-stickers/print/uppercase/plain-sticker-Y.png": 95,
	"./plain-stickers/print/uppercase/plain-sticker-Z.png": 96,
	"./star-empty.png": 574,
	"./star-filled.png": 575,
	"./stickers/cursive/connections/sticker-ad.png": 576,
	"./stickers/cursive/connections/sticker-bo.png": 577,
	"./stickers/cursive/connections/sticker-by.png": 578,
	"./stickers/cursive/connections/sticker-cc.png": 579,
	"./stickers/cursive/connections/sticker-ch.png": 580,
	"./stickers/cursive/connections/sticker-ed.png": 581,
	"./stickers/cursive/connections/sticker-el.png": 582,
	"./stickers/cursive/connections/sticker-gl.png": 583,
	"./stickers/cursive/connections/sticker-it.png": 584,
	"./stickers/cursive/connections/sticker-oa.png": 585,
	"./stickers/cursive/connections/sticker-oe.png": 586,
	"./stickers/cursive/connections/sticker-of.png": 587,
	"./stickers/cursive/connections/sticker-oi.png": 588,
	"./stickers/cursive/connections/sticker-on.png": 589,
	"./stickers/cursive/connections/sticker-or.png": 590,
	"./stickers/cursive/connections/sticker-os.png": 591,
	"./stickers/cursive/connections/sticker-pa.png": 592,
	"./stickers/cursive/connections/sticker-tr.png": 593,
	"./stickers/cursive/connections/sticker-us.png": 594,
	"./stickers/cursive/connections/sticker-ve.png": 595,
	"./stickers/cursive/connections/sticker-wa.png": 596,
	"./stickers/cursive/connections/sticker-wh.png": 597,
	"./stickers/cursive/connections/sticker-wi.png": 598,
	"./stickers/cursive/connections/sticker-yo.png": 599,
	"./stickers/cursive/lowercase/sticker-a.png": 600,
	"./stickers/cursive/lowercase/sticker-b.png": 601,
	"./stickers/cursive/lowercase/sticker-c.png": 602,
	"./stickers/cursive/lowercase/sticker-d.png": 603,
	"./stickers/cursive/lowercase/sticker-e.png": 604,
	"./stickers/cursive/lowercase/sticker-f.png": 605,
	"./stickers/cursive/lowercase/sticker-g.png": 606,
	"./stickers/cursive/lowercase/sticker-h.png": 607,
	"./stickers/cursive/lowercase/sticker-i.png": 608,
	"./stickers/cursive/lowercase/sticker-j.png": 609,
	"./stickers/cursive/lowercase/sticker-k.png": 610,
	"./stickers/cursive/lowercase/sticker-l.png": 611,
	"./stickers/cursive/lowercase/sticker-m.png": 612,
	"./stickers/cursive/lowercase/sticker-n.png": 613,
	"./stickers/cursive/lowercase/sticker-o.png": 614,
	"./stickers/cursive/lowercase/sticker-p.png": 615,
	"./stickers/cursive/lowercase/sticker-q.png": 616,
	"./stickers/cursive/lowercase/sticker-r.png": 617,
	"./stickers/cursive/lowercase/sticker-s.png": 618,
	"./stickers/cursive/lowercase/sticker-t.png": 619,
	"./stickers/cursive/lowercase/sticker-u.png": 620,
	"./stickers/cursive/lowercase/sticker-v.png": 621,
	"./stickers/cursive/lowercase/sticker-w.png": 622,
	"./stickers/cursive/lowercase/sticker-x.png": 623,
	"./stickers/cursive/lowercase/sticker-y.png": 624,
	"./stickers/cursive/lowercase/sticker-z.png": 625,
	"./stickers/cursive/uppercase/sticker-A.png": 626,
	"./stickers/cursive/uppercase/sticker-B.png": 627,
	"./stickers/cursive/uppercase/sticker-C.png": 628,
	"./stickers/cursive/uppercase/sticker-D.png": 629,
	"./stickers/cursive/uppercase/sticker-E.png": 630,
	"./stickers/cursive/uppercase/sticker-F.png": 631,
	"./stickers/cursive/uppercase/sticker-G.png": 632,
	"./stickers/cursive/uppercase/sticker-H.png": 633,
	"./stickers/cursive/uppercase/sticker-I.png": 634,
	"./stickers/cursive/uppercase/sticker-J.png": 635,
	"./stickers/cursive/uppercase/sticker-K.png": 636,
	"./stickers/cursive/uppercase/sticker-L.png": 637,
	"./stickers/cursive/uppercase/sticker-M.png": 638,
	"./stickers/cursive/uppercase/sticker-N.png": 639,
	"./stickers/cursive/uppercase/sticker-O.png": 640,
	"./stickers/cursive/uppercase/sticker-P.png": 641,
	"./stickers/cursive/uppercase/sticker-Q.png": 642,
	"./stickers/cursive/uppercase/sticker-R.png": 643,
	"./stickers/cursive/uppercase/sticker-S.png": 644,
	"./stickers/cursive/uppercase/sticker-T.png": 645,
	"./stickers/cursive/uppercase/sticker-U.png": 646,
	"./stickers/cursive/uppercase/sticker-V.png": 647,
	"./stickers/cursive/uppercase/sticker-W.png": 648,
	"./stickers/cursive/uppercase/sticker-X.png": 649,
	"./stickers/cursive/uppercase/sticker-Y.png": 650,
	"./stickers/cursive/uppercase/sticker-Z.png": 651,
	"./stickers/numbers/sticker-0.png": 652,
	"./stickers/numbers/sticker-1.png": 653,
	"./stickers/numbers/sticker-2.png": 654,
	"./stickers/numbers/sticker-3.png": 655,
	"./stickers/numbers/sticker-4.png": 656,
	"./stickers/numbers/sticker-5.png": 657,
	"./stickers/numbers/sticker-6.png": 658,
	"./stickers/numbers/sticker-7.png": 659,
	"./stickers/numbers/sticker-8.png": 660,
	"./stickers/numbers/sticker-9.png": 661,
	"./stickers/print/lowercase/sticker-a.png": 250,
	"./stickers/print/lowercase/sticker-b.png": 251,
	"./stickers/print/lowercase/sticker-c.png": 252,
	"./stickers/print/lowercase/sticker-d.png": 253,
	"./stickers/print/lowercase/sticker-e.png": 254,
	"./stickers/print/lowercase/sticker-f.png": 255,
	"./stickers/print/lowercase/sticker-g.png": 256,
	"./stickers/print/lowercase/sticker-h.png": 257,
	"./stickers/print/lowercase/sticker-i.png": 258,
	"./stickers/print/lowercase/sticker-j.png": 259,
	"./stickers/print/lowercase/sticker-k.png": 260,
	"./stickers/print/lowercase/sticker-l.png": 261,
	"./stickers/print/lowercase/sticker-m.png": 262,
	"./stickers/print/lowercase/sticker-n.png": 263,
	"./stickers/print/lowercase/sticker-o.png": 264,
	"./stickers/print/lowercase/sticker-p.png": 265,
	"./stickers/print/lowercase/sticker-q.png": 266,
	"./stickers/print/lowercase/sticker-r.png": 267,
	"./stickers/print/lowercase/sticker-s.png": 268,
	"./stickers/print/lowercase/sticker-t.png": 269,
	"./stickers/print/lowercase/sticker-u.png": 270,
	"./stickers/print/lowercase/sticker-v.png": 271,
	"./stickers/print/lowercase/sticker-w.png": 272,
	"./stickers/print/lowercase/sticker-x.png": 273,
	"./stickers/print/lowercase/sticker-y.png": 274,
	"./stickers/print/lowercase/sticker-z.png": 275,
	"./stickers/print/uppercase/sticker-A.png": 224,
	"./stickers/print/uppercase/sticker-B.png": 225,
	"./stickers/print/uppercase/sticker-C.png": 226,
	"./stickers/print/uppercase/sticker-D.png": 227,
	"./stickers/print/uppercase/sticker-E.png": 228,
	"./stickers/print/uppercase/sticker-F.png": 229,
	"./stickers/print/uppercase/sticker-G.png": 230,
	"./stickers/print/uppercase/sticker-H.png": 231,
	"./stickers/print/uppercase/sticker-I.png": 232,
	"./stickers/print/uppercase/sticker-J.png": 233,
	"./stickers/print/uppercase/sticker-K.png": 234,
	"./stickers/print/uppercase/sticker-L.png": 235,
	"./stickers/print/uppercase/sticker-M.png": 236,
	"./stickers/print/uppercase/sticker-N.png": 237,
	"./stickers/print/uppercase/sticker-O.png": 238,
	"./stickers/print/uppercase/sticker-P.png": 239,
	"./stickers/print/uppercase/sticker-Q.png": 240,
	"./stickers/print/uppercase/sticker-R.png": 241,
	"./stickers/print/uppercase/sticker-S.png": 242,
	"./stickers/print/uppercase/sticker-T.png": 243,
	"./stickers/print/uppercase/sticker-U.png": 244,
	"./stickers/print/uppercase/sticker-V.png": 245,
	"./stickers/print/uppercase/sticker-W.png": 246,
	"./stickers/print/uppercase/sticker-X.png": 247,
	"./stickers/print/uppercase/sticker-Y.png": 248,
	"./stickers/print/uppercase/sticker-Z.png": 249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 496;